import React, { useState } from 'react';
import { Container, Row, Col, Form, Button } from 'react-bootstrap';
import { Link, useNavigate } from 'react-router-dom';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
// images
import Logosm from "../images/logo-sm.png"
import GoogleIcon from "../images/google.png"
import FbIcon from "../images/fb.png"
import authBg from "../images/auth-bg.png";
// data
import LoginSliderDataList from "./login-slider-data.json";

export default function Login() {
    const [LoginData] = useState(LoginSliderDataList);
    // navigate
    const navigate = useNavigate();
    const redirectToHome = () => {
        navigate('/home');
    };

    // Form
    const [email, setEmail] = useState('admin@gmail.com');
    const [password, setPassword] = useState('@1234');

    // Check if both fields are filled
    const isFormValid = email.trim() !== '' && password.trim() !== '';

    // Handle input change
    const handleEmailChange = (e) => {
        setEmail(e.target.value);
    };

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
    };

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault();
        // Add your form submission logic here
        alert('Form Submitted');
    };
    return (
        <>
            <div className="auth-page">
                <Container fluid>
                    <Row>
                        <Col md={6} className="bg-primary position-relative auth-hright p-4 p-md-5 d-none d-md-flex justify-content-center align-items-center">
                            <div className="overlay-img" style={{ backgroundImage: `url(${authBg})` }}></div>
                            <Row className='justify-content-center w-100'>
                                <Col xl={9} xxl={8}>
                                    <Swiper className='auth-slider-content custom-slider pb-4_5'
                                        slidesPerView={1}
                                        spaceBetween={50}
                                        pagination={{ dynamicBullets: true }}
                                        modules={[Autoplay, Pagination]}
                                        autoplay={{
                                            delay: 2500,
                                        }}
                                    >
                                        {LoginData.loginDataList.map((data, i) =>
                                            <SwiperSlide key={i}>
                                                <div className='text-center'>
                                                    <div className='mx-auto mb-3'>
                                                        <img src={require(`../images/auth-slider/${data.sliderImg}`)} alt='' className='img-fluid auth-slider-img' />
                                                    </div>
                                                    <h1 className='text-white display-5 mb-0 fw-semibold text-shadow'>{data.sliderTitle}</h1>
                                                </div>
                                            </SwiperSlide>
                                        )}
                                    </Swiper>
                                </Col>
                            </Row>
                        </Col>
                        <Col md={6} className='auth-hright p-4 p-md-5 d-flex justify-content-center align-items-center'>
                            <Row className='justify-content-center'>
                                <Col lg={11}>
                                    <div className="auth-contant">
                                        <div className='avatar avatar-xxl bg-soft-primary border border-soft-primary rounded-circle mx-auto mb-3'>
                                            <img src={Logosm} alt='' height={56} />
                                        </div>
                                        <div className='text-center mb-5'>
                                            <h3 className='fw-semibold'>Welcome to Homle</h3>
                                            <p className='text-muted'>Welcome back! login with your data that you entered during registration.</p>
                                        </div>
                                        <Form onSubmit={handleSubmit}>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Email address</Form.Label>
                                                <div className="position-relative input-right-icon">
                                                    <i className="bi bi-at fs-22 text-muted"></i>
                                                    <Form.Control type="email" size="lg" placeholder="Enter your email..." value={email} onChange={handleEmailChange} />
                                                </div>
                                            </Form.Group>
                                            <Form.Group className="mb-3">
                                                <Form.Label>Password</Form.Label>
                                                <div className="position-relative input-right-icon">
                                                    <i className="bi bi-lock fs-22 text-muted"></i>
                                                    <Form.Control type="password" size="lg" placeholder="Password"  value={password} onChange={handlePasswordChange} />
                                                </div>
                                            </Form.Group>
                                            <Form.Group className="d-flex align-items-center justify-content-between mb-3">
                                                <Form.Check required label="Remember me" />
                                                <Link href="#/" className='text-muted text-end text-decoration-underline'>Forgot your password?</Link>
                                            </Form.Group>
                                            <Button onClick={redirectToHome} disabled={!isFormValid} className="primary w-100">Login</Button>
                                        </Form>

                                        <p className='auth-or-text text-muted text-center my-4'>or</p>
                                        <div className="d-flex flex-wrap gap-16 justify-content-center">
                                            <Link to="/" className='auth-btn'>
                                                <img src={GoogleIcon} alt="" width={26} height={26} /> <span className='ms-2'>Login with google</span>
                                            </Link>
                                            <Link to="/" className='auth-btn'>
                                                <img src={FbIcon} alt="" width={26} height={26} /> <span className='ms-2'>Login with facebook</span>
                                            </Link>
                                        </div>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Container>
            </div>
        </>
    )
}
